import React, { useMemo } from 'react';
import { Form, GroupItem, Item, RequiredRule, RangeRule, Label } from 'devextreme-react/form';
import useHandleWorkCenter from '../../../Hooks/useHandleData/useHandleWorkCenter';
   
const dateMin = new Date(Date.now() - 14 * 24 * 60 * 60 * 1000),
    dateMax = new Date(Date.now() + 24 * 60 * 60 * 1000),
    totalHoursOptions = {
        width: '100%'
    },
    descriptionOptions = {
        height: 90
    },
    dateOptions = {
        width: '100%',
        type: 'date',
        displayFormat: "shortdate",
        showClearButton: true,
        placeholder: "mm/dd/yyyy"
    };

const DefaultForm = ({ formData, formRef, formFieldDataChanged, isSingleTask, taskOptions, billingAndWorkOptions, isOtherUser, formInstance }) => {
    const { workCenters } = useHandleWorkCenter();
    const locationOptions = useMemo(() => ({
        items: workCenters,
        valueExpr: "id",
        displayExpr: "name",
        searchEnabled: true,
        placeholder: "Type or Select..."
    }), [workCenters]);

    return (
        <Form
            onInitialized={(e) => formInstance.current = e.component}
            formData={formData}
            ref={formRef}
            onFieldDataChanged={formFieldDataChanged}
            showValidationSummary={true}>
            <GroupItem colCount={2}>
                <Item
                    isRequired
                    dataField="locationId"
                    editorType="dxSelectBox"
                    validationGroup="uploadHours"
                    editorOptions={locationOptions}
                    colSpan={2}>
                    <RequiredRule message="Location is required" />
                </Item>
                <Item
                    key='task'
                    isRequired={!isSingleTask}
                    dataField="taskId"
                    editorType="dxSelectBox"
                    editorOptions={taskOptions}
                    visible={!isSingleTask}
                    colSpan={2}>
                </Item>
                <Item
                    dataField="billingAndWorkId"
                    editorType="dxSelectBox"
                    editorOptions={billingAndWorkOptions}
                    colSpan={2}
                    isRequired>
                    <Label text="Billing Code or Work Order" />
                    <RequiredRule message={formData.billingAndWorkOrderType === "Operation" ? "Work Order is required" : "Billing Code is required"} />
                </Item>
                <GroupItem colSpan={2} colCount={2}>
                    <Item
                        dataField='startDate'
                        editorType="dxDateBox"
                        editorOptions={dateOptions}
                        isRequired={true}
                        colSpan={1}>
                        <RequiredRule message="Date is required" />
                        {!isOtherUser && <RangeRule min={dateMin} message="Contact your supervisor to add hours for previous weeks" />}
                        <RangeRule max={dateMax} message="Can not add hours for future dates" />
                    </Item>
                    <Item
                        dataField="totalHours"
                        isRequired
                        editorType="dxNumberBox"
                        editorOptions={totalHoursOptions}
                        colSpan={1}>
                        <RangeRule min={0} max={8} />
                        <RequiredRule message="Total hours is required" />
                    </Item>
                </GroupItem>
                <Item
                    dataField="description"
                    editorType="dxTextArea"
                    editorOptions={descriptionOptions}
                    colSpan={2}>
                    <Label text='Provide a brief description of what you did' />
                </Item>
            </GroupItem>
        </Form>
    );
};

export default DefaultForm;
